module.exports = __webpack_public_path__ + "img/solution-pc-400.3d73a206.png";